"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPicker = void 0;
const react_1 = __importDefault(require("react"));
const react_day_picker_1 = __importDefault(require("react-day-picker"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const locale_1 = require("../../../utils/locale");
require("react-day-picker/lib/style.css");
require("./index.scss");
const DayPicker = (props) => {
    const { modificators } = props;
    const intl = (0, react_intl_1.useIntl)();
    const classNames = (0, classFunctions_1.getClassNames)('day-picker', modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(react_day_picker_1.default, { ...props, firstDayOfWeek: 1, locale: (0, locale_1.mapLocaleToLocaleCode)(intl.locale) })));
};
exports.DayPicker = DayPicker;
//# sourceMappingURL=index.js.map